import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'



const getDefaultStateForPurchasePrice = () => {
  return {
    purchase_prices: [],
    is_created:null,
    is_deleted:null
  }
}

// state
const state = getDefaultStateForPurchasePrice()

const getters = {

}

// mutations
const mutations = {
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    RESET_STATE_FOR_PURCHASE_PRICES (state) {
      Object.assign(state, getDefaultStateForPurchasePrice())
    },
}

// actions
const actions = {
    resetState({ commit }, payload) {
      commit("RESET_STATE_FOR_PURCHASE_PRICES")
    },
    async create({ commit }, data) {
        await axios
            .post(apiRoutes['CREATE_PURCHASE_PRICE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                    commit('SET_IS_CREATED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: "Purchase Price has been created!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
              }
              else
              {
                  let errors = response.data.data.errors
                  commit('SET_IS_CREATED', 0);
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Creating Purchase Price")
                }
            });
    },
    async delete({ commit }, data) {
        await axios
            .post(apiRoutes['DELETE_PURCHASE_PRICE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                    commit('SET_IS_DELETED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: "Purchase Price has been deleted!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
              }
              else
              {
                  let errors = response.data.data.errors
                  commit('SET_IS_DELETED', 0);
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                commit('SET_IS_DELETED', 0);
                if (error.response) 
                {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Deleted Purchase Price")
                }
            });
      },
}

export {
    state,
    getters,
    actions,
    mutations
}
